import SimpleOrderService from '../../services/SimpleOrderService';
import simpleOrderUseCase from './simpleOrderUseCase';

const simpleOrderFactory = simpleOrderUseCase({
  SimpleOrderService: SimpleOrderService(),
});

export default simpleOrderFactory;
